import { SearchIcon, MoneyIcon, FacebookIcon, InstagramIcon, TargetIcon, WorldwideIcon } from '@/components/icons'

const ICONS = {
    SearchIcon: <SearchIcon className="tw:size-5 tw:text-gray-200" />,
    MoneyIcon: <MoneyIcon className="tw:size-5 tw:text-gray-200" />,
    FacebookIcon: <FacebookIcon className="tw:size-5 tw:text-gray-200" />,
    InstagramIcon: <InstagramIcon className="tw:size-5 tw:text-gray-200" />,
    TargetIcon: <TargetIcon className="tw:size-5 tw:text-gray-200" />,
    WorldwideIcon: <WorldwideIcon className="tw:size-5 tw:text-gray-200" />,
}

export const AudienceIcon = ({ icon }) => ICONS[icon]
